<!--
  Full-screen sign-in state. The user has nothing to do here — SSO is kicked off
  automatically on init — so the screen says exactly that and nothing else.
-->
<div class="login-screen" data-testid="login-screen">

  <div class="login-card">
    <p class="login-brand">AZ Symphony</p>

    <app-spinner
      [display]="true"
      [class]="'login-spinner'"
      [diameter]="64"
      [messageToDisplay]="'Signing you in automatically…'"
    ></app-spinner>

    <p class="login-hint" data-testid="login-hint">
      Redirecting to your AstraZeneca account. This only takes a moment.
    </p>
  </div>

</div>
